import { Chip } from '@heroui/react';
import React from 'react';

export type PillVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'default';
export type PillSize = 'sm' | 'md' | 'lg';

interface PillProps {
  children: React.ReactNode;
  variant?: PillVariant;
  size?: PillSize;
  className?: string;
  startContent?: React.ReactNode;
  onClick?: () => void;
}

export const Pill: React.FC<PillProps> = ({
  children,
  variant = 'default',
  size = 'sm',
  className,
  startContent,
  onClick,
}) => {
  const getCustomStyles = (pillVariant: PillVariant) => {
    const baseClasses = 'text-white font-medium !px-3 !py-1.5';
    switch (pillVariant) {
      case 'primary':
        return `${baseClasses} bg-[#3D6BFF]`;
      case 'success':
        return `${baseClasses} bg-green-500`;
      case 'warning':
        return `${baseClasses} bg-yellow-500 text-black`;
      case 'danger':
        return `${baseClasses} bg-red-500`;
      case 'secondary':
        return `${baseClasses} bg-purple-500`;
      default:
        return `${baseClasses} bg-gray-500`;
    }
  };

  return (
    <Chip
      size={size}
      variant="solid"
      startContent={startContent}
      className={`${getCustomStyles(variant)} ${className || ''}`}
      onClick={onClick}
    >
      {children}
    </Chip>
  );
};
